'use strict';

import React from 'react';
import FontAwesome from 'react-fontawesome';
//require('styles//Header.css');

class Header extends React.Component {
	constructor(props){
	  	super(props)
	  	this.state = {
	  		status: '',
	  		url: '',
	    	latitude: '',
	    	longitude: '',
	    	description: ''
	  	}
	}

	componentDidMount(){
	  	PubSub.subscribe('STATUS', (e,d) => {
	    	//console.log(d)
	    	this.setState({
	    		status: d.type
	    	});

	    	if(d.type == "LOCATION_INFO"){
	      		this.setState({
	      			url: d.data.url,
	        		latitude: d.data.latitude,
	        		longitude: d.data.longitude,
	        		shortDescription: d.data.shortDescription
	      		})
	    	}
	  	})
	}

	render() {
		let infosClass = this.state.status != "TELEPORT_DONE" ?
		"hidden" :
		""
		return (
			<header>
				<div className="row">
					<div className="col-xs-12 col-md-6">
						<h1 itemProp="name">T-E-L-E-P-O-R-T.ME</h1>
					</div>
					<div className="col-xs-12 col-md-6">
						<div className={"infos " + infosClass}>
							<a target="_blank" href={this.state.url}>
								<div className="coords ">
								    <span id="latitude">{this.state.latitude}</span>, 
								    <span id="longitude">{this.state.longitude}</span>
								</div>
								<div id="description">
									{this.state.shortDescription} <FontAwesome name='location-arrow' />
								</div>
								<div id="count"></div>   
							</a>
						</div> 
					</div>
				</div>
				
			</header>
		);
	}
}

Header.displayName = 'Header';

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js